import { UseFormReturn } from "react-hook-form";

import { useGlobalData } from "../../GlobalDataProvider";
import { IModuleRound, useRound } from "../../../modules/roundHandler";
import { IGlobalData, MapTooltip } from "../../../types/globalData";
import Funktionskontroller from "./Funktionskontroller";
import BFLNote from "./BFLNote";
import { bfv_J8 } from "../../../modules/Beräkningsmoduler/BFV_J8";
import ErrorInfo from "./ErrorInfo";
import DebugInfo from "./DebugInfo";
import DriftOptimeringar from "./DriftOptimeringar";
import { Card } from "react-bootstrap";
import NumberEditor from "../../Global/Editors/NumberEditor";
import { nameof } from "../../Global/Utils";
import { IJ12_BFData, IJ8_BFData } from "../../../types/BFDatas";
import SelectEditor from "../../Global/Editors/SelectEditor";
import CheckboxEditor from "../../Global/Editors/CheckboxEditor";
import { IModuleVattenburetSekundärsystem } from "../../../types/ModuleDatas";

interface IProps {
  module: IModuleRound;
  formHook: UseFormReturn;
}

const BFV_J8 = ({ module, formHook }: IProps) => {
  const roundHandler = useRound();
  const global = useGlobalData();

  const bimHandler = roundHandler.getBimHandler();

  formHook.watch(); //Rerender for any changes in inputs

  const harAngettNyInställningPumpstopp = formHook.watch("data.harAngettNyInställningPumpstopp");

  const formData: any = formHook.getValues();

  //if (module.bfs.BFV_J8 && formData.data) module.bfs.BFV_J8.data = formData.data;
  const bm = bfv_J8().getResult(module, bimHandler, roundHandler, global.data as IGlobalData, formData);

  const { funktionsKontroller, driftOptimeringar, data } = bm;

  const systemText = global.beräkningsflikarText.beskr_BFV_J8;

  const moduleData = module.data as IModuleVattenburetSekundärsystem;
  const pumpstoppSaknas = moduleData.pumpstoppSaknas;
  const pumpstoppInstallning = new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 1 }).format(moduleData.pumpstoppInstallning);

  return (
    <div>
      <Card className="mb-3">
        <Card.Header>{systemText?.title}</Card.Header>
        <Card.Body>
          {/* Funktionskontroll för Vattenburet sekundärvärmesystem. Regleravvikelse framledning. */}
          <div dangerouslySetInnerHTML={{ __html: systemText?.body as string }} />

          {pumpstoppSaknas ? (
            <></>
          ) : (
            <>
              <Card className="mb-3">
                <Card.Header>Manuella kontroller</Card.Header>
                <Card.Body>
                  <div className="row overflow-hidden gy-0">
                    <div className="col-lg-6">
                      <SelectEditor
                        label={"Pumpstopp aktiveras vid överskridet gränsvärde? (Ja / Nej)"}
                        items={["", "Ja", "Nej"]}
                        fieldName={"data." + nameof<IJ8_BFData>("pumpstoppAktiveras")}
                        tooltipId={nameof<MapTooltip>("BFVJ8_pumpstoppAktiveras")}
                        formHook={formHook}
                        options={{
                          validate: {
                            required: (value: any) => (value ? undefined : "Ja / Nej"),
                          },
                        }}
                      ></SelectEditor>
                    </div>
                    <div className="col-lg-6">
                      <SelectEditor
                        label={"Styrande givare utetemperatur OK? (Ja / Nej)"}
                        items={["", "Ja", "Nej"]}
                        fieldName={"data." + nameof<IJ8_BFData>("styrandeTemperaturgivareOk")}
                        tooltipId={nameof<MapTooltip>("BFVJ8_styrandeTemperaturgivareOk")}
                        formHook={formHook}
                        options={{
                          validate: {
                            required: (value: any) => (value ? undefined : "Ja / Nej"),
                          },
                        }}
                      ></SelectEditor>
                    </div>
                  </div>
                  <div className="row ml-0">
                    <div className="col-lg-6">
                      <SelectEditor
                        label="Har angivit nytt inställningsvärde för pumpstopp"
                        formHook={formHook}
                        fieldName={"data." + nameof<IJ8_BFData>("harAngettNyInställningPumpstopp")}
                        tooltipId={nameof<MapTooltip>("BFVJ8_harAngettNyInställningPumpstopp")}
                        items={["", "Ja", "Nej"]}
                        options={{
                          validate: {
                            required: (value: any) => (value ? undefined : "Ja / Nej"),
                          },
                        }}
                      ></SelectEditor>
                    </div>
                    <div className="col-lg-6">
                      {harAngettNyInställningPumpstopp === "Ja" ? (
                        <NumberEditor
                          label={"Nytt inställningsvärde pumpstopp (Befintligt värde: " + pumpstoppInstallning + ")"}
                          formHook={formHook}
                          fieldName={"data." + nameof<IJ8_BFData>("nyInställningPumpstopp")}
                          tooltipId={nameof<MapTooltip>("BFVJ8_nyInställningPumpstopp")}
                          min={10}
                          max={25}
                          step={0.1}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </>
          )}
          <Funktionskontroller bfName="BFV_J8" formHook={formHook} funktionsKontroller={funktionsKontroller} />
          <DriftOptimeringar bfName="BFV_J8" formHook={formHook} driftOptimeringar={driftOptimeringar} />
          <div className="mb-3">
            <BFLNote formHook={formHook} />
          </div>

          <ErrorInfo info={bm.error} />
          <DebugInfo info={bm.debug} />
        </Card.Body>
      </Card>
    </div>
  );
};

export default BFV_J8;
